<template>
    <header class="flex h-14 shrink-0 items-center justify-end gap-1 border-b border-surface-200 bg-surface-0 px-4 dark:border-surface-800 dark:bg-surface-900">
        <span class="mr-2 text-sm text-surface-600 dark:text-surface-300">{{ appStore.userData?.username }}</span>
        <Button text rounded :label="appStore.locale.toUpperCase()" @click="toggleLocale" />
        <Button text rounded :icon="appStore.dark ? 'pi pi-sun' : 'pi pi-moon'" @click="appStore.toggleDark()" />
        <Button v-tooltip.bottom="$t('nav.logout')" text rounded severity="danger" icon="pi pi-sign-out" @click="logout" />
    </header>
</template>

<script lang="ts" setup>
    import { useRouter } from 'vue-router'
    import { Button } from 'primevue'

    import { useAppStore } from '@/stores/app'

    const appStore = useAppStore()
    const router = useRouter()

    const toggleLocale = () => appStore.changeLocale(appStore.locale === 'sl' ? 'en' : 'sl')

    const logout = async () => {
        appStore.setLogout()
        await router.push({ name: 'login' })
    }
</script>
